import Vue from 'vue'
import { GET_AUTH_TOKEN, GET_AUTH_USER, DELETE_AUTH_TOKEN, DELETE_AUTH_USER, DELETE_GOOGLE_TOKEN, SELECT_CALENDAR_USERS } from 'src/vuex/mutation-types'

export const login = ({ state, dispatch }, credentials) => {
  Vue.http.post('login', credentials)
    .then(
      response => {
        dispatch(GET_AUTH_TOKEN, response.json().token)
        Vue.http.get('user-info').then(
          response => {
            dispatch(GET_AUTH_USER, response.json().user)
            dispatch(SELECT_CALENDAR_USERS, [response.json().user.id])
          })
      }
    )
}

export const getAuthenticatedUser = ({ dispatch }) => {
  Vue.http.get('user-info').then(
    response => {
      dispatch(GET_AUTH_USER, response.json().user || '')
    }
  )
}

export const logout = ({ dispatch }) => {
  dispatch(DELETE_AUTH_TOKEN)
  dispatch(DELETE_AUTH_USER)
  dispatch(DELETE_GOOGLE_TOKEN)
  window.localStorage.clear()
}

export const checkUserFromStorage = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    if (window.localStorage.getItem('AUTH_TOKEN')) {
      dispatch(GET_AUTH_TOKEN, window.localStorage.getItem('AUTH_TOKEN'))
    }
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/authActions.js